import http from '@/services/http'
import { sleep } from '@/utils'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    users: [],
    count: 0,
  },
  mutations: {
    START_FETCH: (state) => {
      state.fetchInProgress = true
    },
    STOP_FETCH: (state) => {
      state.fetchInProgress = false
    },
    SET_USER_LIST_DATA: (state, { users, count }) => {
      state.users = users
      state.count = count
    },
    ADD_USER: (state, user) => {
      state.users = state.users.concat(user)
    },

    START_USER_CHANGE: (state, user) => {
      state.users = state.users.map((u) => {
        if (u.id === user.id) {
          u.change_in_progress = true
        }
        return u
      })
    },
    STOP_USER_CHANGE: (state, user) => {
      state.users = state.users.map((u) => {
        if (u.id === user.id) {
          u.change_in_progress = false
        }
        return u
      })
    },
    DEACTIVATED_USER: (state, { userId }) => {
      state.users = state.users.map((user, i) => {
        if (user.id === userId) {
          return Object.assign({}, user, { is_active: false })
        } else {
          return user
        }
      })
    },
    ACTIVATED_USER: (state, { userId }) => {
      state.users = state.users.map((user, i) => {
        if (user.id === userId) {
          return Object.assign({}, user, { is_active: true })
        } else {
          return user
        }
      })
    },

    toggleFeature(state, { userId, feature }) {
      state.users = state.users.map((user) => {
        const newUser = { ...user }
        if (user.id === userId) {
          if (newUser.features.includes(feature)) {
            newUser.features = newUser.features.filter((f) => f !== feature)
          } else {
            newUser.features.push(feature)
          }
        }
        return newUser
      })
    },
  },
  actions: {
    async fetch({ commit }, opts) {
      const defaults = { page: 1 }
      opts = opts || {}
      opts = { ...defaults, ...opts }
      commit('START_FETCH')
      const response = await http.getAuthed('/admin/users', opts)
      commit('SET_USER_LIST_DATA', {
        users: response.data.results,
        count: response.data.count,
      })
      commit('STOP_FETCH')
    },
    async deactivateUser({ commit }, user) {
      await changeUserActivity({ commit, user, isActive: false })
    },
    async activateUser({ commit }, user) {
      await changeUserActivity({ commit, user, isActive: true })
    },

    async toggleFeature({ commit }, { userId, feature }) {
      commit('toggleFeature', { userId, feature })
      const url = `/admin/users/${userId}/toggle-feature`
      await http.postAuthed(url, { user_id: userId, feature })
    },
  },
}

async function changeUserActivity({ commit, user, isActive }) {
  commit('START_USER_CHANGE', user)
  const url = {
    true: `/admin/users/${user.id}/activate`,
    false: `/admin/users/${user.id}/deactivate`,
  }[isActive]
  const request = http.postAuthed(url)
  await sleep(1000)
  await request

  const DONE_MUTATION_NAME = {
    true: 'ACTIVATED_USER',
    false: 'DEACTIVATED_USER',
  }[isActive]
  commit(DONE_MUTATION_NAME, { userId: user.id })
  commit('STOP_USER_CHANGE', user)
}
